import React, { Component } from 'react'
import Combokeys from 'combokeys'
import './style'


export default class Grid extends Component {
	constructor(props) {
		super(props)
		this.toggleActive = this.toggleActive.bind(this)
		this.state = { active: false }
		this.combokeys = new Combokeys(document.documentElement)
	}

	componentWillMount() {
		this.combokeys.bind('alt+shift+g', this.toggleActive)
	}

	componentWillUnmount() {
		this.combokeys.detach()
	}

	toggleActive() {
		this.setState(prevState => ({
			active: !prevState.active,
		}))
	}

	render() {
		const active = this.state.active ? 'active' : ''
		return (
			<div className={`${active} grid`}>
				<div className="container">
					<div className="col" />
					<div className="col" />
					<div className="col" />
					<div className="col" />
					<div className="col" />
					<div className="col" />
				</div>
			</div>
		)
	}
}
